import { createContext } from 'react';
export const ExpressCheckoutButtonsContext = /*#__PURE__*/createContext(undefined);
//# sourceMappingURL=ExpressCheckoutButtonsContext.js.map